import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, FirstItem, LastTableItem, TableBodyRow } from './PartnersPage.styles.js';

import { selectActivatePartnerUserPending, selectFetchPartnerUsersPending, selectPartnerUsers } from '../../store/slices/partners/slice.js';
import { activatePartnerUser, fetchPartnerUsers, loginToPartnerUser } from '../../store/slices/partners/asyncThunks.js';

import { formatDate } from '../../utils/utils.js';
import openToast from '../../utils/toast.js';

import TableItem from '../../components/Table/TableItem.js';
import Table from '../../components/Table/Table.js';
import MainContainer from '../../components/utils/MainContainer/MainContainer.js';

import { ReactComponent as Loading } from '../../assets/icons/loader-white.svg';
import { PARTNER_FRONT_URL, PARTNER_FRONT_URL_STAGING } from '../../utils/constants.js';
import { FRONT_URL } from '../../api/index.js';

const tableHeader = [
  {
    label: 'partners-name',
    sortable: true,
    key: 'partnersName',
  },
  {
    label: 'signup-date',
    sortable: true,
    key: 'signupDate',
  },
  {
    label: 'of-products',
    sortable: true,
    key: 'ofProducts',
  },
  {
    label: 'status',
    sortable: true,
    key: 'status',
  },
  {
    label: 'last-update',
    sortable: true,
    key: 'lastUpdate',
  },
  {
    label: 'actions',
    sortable: false,
    key: 'actions',
  },
];

const PartnersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toastId = useRef(null);
  const location = useLocation();

  const [searchTerm, setSearchTerm] = useState('');

  const { data, maxReached, page, total, perPage } = useSelector(selectPartnerUsers);
  const fetchPartnerUsersPending = useSelector(selectFetchPartnerUsersPending);

  const [activatingUserId, setActivatingUserId] = useState('');

  const activatePartnerUserPending = useSelector(selectActivatePartnerUserPending);

  const queryParams = new URLSearchParams(location.search);
  const pageParam = queryParams.get('page');

  useEffect(() => {
    dispatch(fetchPartnerUsers({ page: pageParam }))
      .unwrap()
      .then(() => {})
      .catch(err => openToast(toastId, 'error-fetching', 'error', err.message));
  }, [dispatch, pageParam]);

  const handlePageChange = pageNumber => {
    const query = { page: pageNumber };
    const queryString = new URLSearchParams(query).toString();
    const url = `/partners?${queryString}`;
    navigate(url);
  };

  const activatePartner = id => {
    setActivatingUserId(id);
    if (!activatePartnerUserPending) {
      dispatch(activatePartnerUser(id))
        .unwrap()
        .then(() => {
          setActivatingUserId(null);
        })
        .catch(error => {
          setActivatingUserId(null);
          // toast.error(t(error.message));
        });
    }
  };

  const handleLogin = partnerUserId => {
    dispatch(loginToPartnerUser(partnerUserId))
      .unwrap()
      .then(response => {
        let link = FRONT_URL.includes('staging') ? PARTNER_FRONT_URL_STAGING : PARTNER_FRONT_URL;
        const newTab = window.open(link, '_blank');
        const sendToken = () => {
          if (newTab) {
            newTab.postMessage({ accessToken: response.data.accessToken }, link);
          }
        };
        setTimeout(sendToken, 1000);
      })
      .catch(async err => {
        openToast(toastId, 'login', 'error', t(err.message));
      });
  };

  return (
    <MainContainer pageTitle={'partners'}>
      <Table
        key={searchTerm}
        headerInformation={tableHeader}
        totalCount={total}
        currentPage={+pageParam}
        setPage={handlePageChange}
        perPage={perPage}
        noDataContent={t('no-data')}
        lastColumnAligned
        maxReached={maxReached}
        dataLength={data.length}
        dataLoading={fetchPartnerUsersPending}
        centerText>
        {data.map((user, key) => {
          return (
            <TableBodyRow key={key} $offClick>
              <FirstItem showHover data={user?.fullName} center />
              <TableItem data={formatDate(user?.createdAt) || '/'} center />
              <TableItem data={user?.numOfItems || '/'} center />
              <TableItem data={user?.active ? t('active') : t('pending')} center />
              <TableItem data={formatDate(user?.updatedAt) || '/'} center />
              <LastTableItem
                $offClick
                data={
                  user?.active ? (
                    <Button
                      onClick={() => {
                        handleLogin(user.id);
                      }}>
                      {t('log-in')}
                    </Button>
                  ) : (
                    <Button
                      $accepted
                      onClick={() => {
                        activatePartner(user.id);
                      }}>
                      {activatingUserId === user.id && activatePartnerUserPending ? <Loading height={20} /> : t('activate')}
                    </Button>
                  )

                  // user?.active ? (
                  //   <Button $accepted>{t("log-in")}</Button>
                  // ) : activatingUserId === user.id &&
                  //   activatePartnerUserPending ? (
                  //   <Button
                  //     onClick={() => {
                  //       activatePartner(user.id);
                  //     }}
                  //   >
                  //     {t("activate")}
                  //   </Button>
                  // ) : (
                  //   <Button>
                  //     <Loading height={20} />
                  //   </Button>
                  // )
                }
              />
            </TableBodyRow>
          );
        })}
      </Table>
    </MainContainer>
  );
};

export default PartnersPage;
